package co.maytes.standupbot.dashboard.features.settings

import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.Month
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atTime
import kotlinx.datetime.minus
import kotlinx.datetime.plus
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime

object TimezonePreview {
    private const val STANDUP_HOUR = 9
    private val utc = TimeZone.UTC

    fun nextWeekday(today: LocalDate): LocalDate {
        var day = today.plus(1, DateTimeUnit.DAY)
        while (day.dayOfWeek == DayOfWeek.SATURDAY || day.dayOfWeek == DayOfWeek.SUNDAY) {
            day = day.plus(1, DateTimeUnit.DAY)
        }
        return day
    }

    fun describe(zoneId: String, today: LocalDate): String? {
        val zone = runCatching { TimeZone.of(zoneId) }.getOrNull() ?: return null
        val day = nextWeekday(today)
        val instant = day.atTime(LocalTime(STANDUP_HOUR, 0)).toInstant(zone)
        val local = format(instant.toLocalDateTime(zone))
        val inUtc = format(instant.toLocalDateTime(utc))
        return if (zoneId == "UTC" || zone == utc) {
            "A standup set for 09:00 posts on $local UTC."
        } else {
            "A standup set for 09:00 posts on $local in $zoneId, which is $inUtc in UTC."
        }
    }

    private fun format(at: LocalDateTime): String {
        val weekday = at.dayOfWeek.name.take(WEEKDAY_CHARS).lowercase().replaceFirstChar { it.uppercase() }
        val month = at.month.shortName()
        val hour = at.hour.toString().padStart(2, '0')
        val minute = at.minute.toString().padStart(2, '0')
        return "$weekday ${at.dayOfMonth} $month, $hour:$minute"
    }

    private fun Month.shortName(): String = name.take(WEEKDAY_CHARS).lowercase().replaceFirstChar { it.uppercase() }

    private const val WEEKDAY_CHARS = 3
}

object RetentionWindow {
    const val TRACK_DAYS = 90

    fun keptFraction(days: Int): Double = days.coerceIn(0, TRACK_DAYS).toDouble() / TRACK_DAYS

    fun cutoff(today: LocalDate, days: Int): LocalDate = today.minus(days, DateTimeUnit.DAY)

    fun describe(today: LocalDate, days: Int): String {
        val date = cutoff(today, days)
        val month = date.month.name.take(MONTH_CHARS).lowercase().replaceFirstChar { it.uppercase() }
        return "Raw activity from before ${date.dayOfMonth} $month ${date.year} is deleted each night. " +
            "Everything after it is kept."
    }

    private const val MONTH_CHARS = 3
}

object LeaveKeywordPreview {
    const val SAMPLE_STATUS = "Heading off, on annual leave until the 3rd"

    fun firstMatch(keywordsCsv: String, sample: String = SAMPLE_STATUS): String? {
        val haystack = sample.lowercase()
        return keywordsCsv
            .split(",")
            .map { it.trim().lowercase() }
            .filter { it.isNotEmpty() }
            .firstOrNull { it in haystack }
    }
}
